import React, { useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Button, Typography, Input, Space, Form } from "antd";
import { withTranslation } from "react-i18next";
import IsOverdueIcon from "../assets/svg/IsOverdueIcon";
import { selectSite, selectIsFetching, selectUserId } from "../store/selector";
import { ApiNames } from "../api/api";
import ACTIONS from "../store/action";

const { Title, Text } = Typography;
const { TextArea } = Input;

const ContactSupportComponent = ({ t, patient, isFeching, setShowSupport, userId, sentSupportTicketAct, site }) => {
  const [subject, setSubject] = useState("");
  const [form] = Form.useForm();

  const onSend = (values) => {
    sentSupportTicketAct(values.subject, values.description, patient.patient.id, userId);
  };

  return (
    <Form form={form} name="contactSupport" onFinish={(values) => onSend(values)}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
        <Title level={2} style={{ padding: 16 }}>
          {t("support.title", { site, id: patient ? patient.patient.id : "unknown" })}
        </Title>
        <Space direction="vertical" style={{ width: "60%" }}>
          <Form.Item
            name="subject"
            rules={[
              {
                required: true,
                message: t("support.subject_required")
              },
              {
                max: 49,
                message: "Subject should be less than 50 character"
              }
            ]}
            style={{ marginBottom: 0 }}
          >
            <Input
              size="large"
              maxLength={50}
              placeholder={t("support.subject")}
              bordered={false}
              style={{ borderBottom: "1px solid #9B9B9B" }}
              onChange={(value) => setSubject(value.target.value)}
              suffix={<Text style={{ color: "#9B9B9B" }}>{`${subject.length}/50`}</Text>}
            />
          </Form.Item>
          <Space>
            <div style={{ display: "flex", alignItems: "center", paddingTop: 6 }}>
              <IsOverdueIcon />
              <Text style={{ paddingLeft: 6, color: "#CA367E" }}>{t("support.disclaimer")}</Text>
            </div>
          </Space>
        </Space>
        <Form.Item
          name="description"
          rules={[
            { required: true, message: t("support.description_required") },
            {
              max: 249,
              message: "Description should be less than 250 character"
            }
          ]}
          style={{ paddingTop: 40, width: "60%" }}
        >
          <TextArea placeholder={t("support.description")} rows={8} showCount={true} maxLength={250} />
        </Form.Item>
        <div style={{ display: "flex", justifyContent: "flex-end", width: "60%" }}>
          <Form.Item>
            <Space>
              <Button type="text" onClick={() => setShowSupport(false)}>
                <Text style={{ color: "#2B56A3" }}>{t("cancel")}</Text>
              </Button>
              <Button htmlType="submit" loading={isFeching} type="primary">
                {t("send")}
              </Button>
            </Space>
          </Form.Item>
        </div>
      </div>
    </Form>
  );
};

const mapDispatchToProps = (dispatch) => ({
  sentSupportTicketAct: (subject, description, patient, user) =>
    dispatch(ACTIONS.sentSupportTicketAction(subject, description, patient, user))
});

const mapStateToProps = createStructuredSelector({
  userId: selectUserId,
  isFeching: selectIsFetching([ApiNames.Support]),
  site: selectSite
});

const ContactSupport = connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ContactSupportComponent));

export { ContactSupport };
